import React, { Component } from 'react';
import {DaysOfTheWeekBooleans} from "../common/DaysOfTheWeekBooleans";

class ScheduleConfigurationContent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            itemScheduleConfiguration: props.itemScheduleConfiguration
        };

        this.handleWeekdayChange = this.handleWeekdayChange.bind(this);
    }

    handleWeekdayChange(name, value) {
        const itemScheduleConfiguration = this.state.itemScheduleConfiguration;

        if (name === "schedule_configuration_monday")
            itemScheduleConfiguration.setWorksOnMonday(value);
        else if (name === "schedule_configuration_tuesday")
            itemScheduleConfiguration.setWorksOnTuesday(value);
        else if (name === "schedule_configuration_wednesday")
            itemScheduleConfiguration.setWorksOnWednesday(value);
        else if (name === "schedule_configuration_thursday")
            itemScheduleConfiguration.setWorksOnThursday(value);
        else if (name === "schedule_configuration_friday")
            itemScheduleConfiguration.setWorksOnFriday(value);
        else if (name === "schedule_configuration_saturday")
            itemScheduleConfiguration.setWorksOnSaturday(value);
        else if (name === "schedule_configuration_sunday")
            itemScheduleConfiguration.setWorksOnSunday(value);

        this.setState({...this.state, itemScheduleConfiguration: itemScheduleConfiguration}, () => this.props.onChange(itemScheduleConfiguration));
    }

    render() {
        return <DaysOfTheWeekBooleans name={"schedule_configuration"}
                                      monday={this.state.itemScheduleConfiguration.worksOnMonday()}
                                      tuesday={this.state.itemScheduleConfiguration.worksOnTuesday()}
                                      wednesday={this.state.itemScheduleConfiguration.worksOnWednesday()}
                                      thursday={this.state.itemScheduleConfiguration.worksOnThursday()}
                                      friday={this.state.itemScheduleConfiguration.worksOnFriday()}
                                      saturday={this.state.itemScheduleConfiguration.worksOnSaturday()}
                                      sunday={this.state.itemScheduleConfiguration.worksOnSunday()}
                                      onWeekdayChange={this.handleWeekdayChange}

        />;
    }
}

export default ScheduleConfigurationContent;
